namespace Areas.Finance.Edit {
    "use strict";

    var tabItems = Areas.createTabsWithSameAction("Finance", "Edit",
        ["Balances","DailyGL", "MonthlyGL", "Funding","IrsDeclarations","Memos","Research","Reports"]);

    export function tabInitialized(params: any) {
        return Areas.tabInitialized(tabItems)(params);
    }

    export function updateReconcileProfile() {
        const form = $("#ReconcileProfileForm").dxForm("instance");
        const newData: any = form.option("formData");
        const result: any = form.validate();
        const keyId: any = form.option("KeyId");

        if (result.isValid && keyId != null) {
            sendRequest(`/Reconcile/Profile/Put/${keyId}`, JSON.stringify(newData), "PUT");
        }
    }

    export function returnToListFromTab() {
        var linkInfo = "/Reconcile/List/Active";
        location.href = linkInfo;

    }
}